export const loaderImg = require("../assets/images/loader.gif");
export const loaderImg2 = require("../assets/images/loader2.gif");
export const loaderImgColoured = require("../assets/images/loderColoured.gif");
export const brandLogo = require("../assets/images/brandLogoDesktop.png");
export const chedckIcon = require("../assets/images/check.png");
